/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.model.reminder

object ReminderTemplate {
    const val PLACEHOLDER_PATIENT_NAME = "{patient_name}"
    const val PLACEHOLDER_AMOUNT_OWED = "{amount_owed}"
    const val PLACEHOLDER_SESSION_COUNT = "{session_count}"
    const val PLACEHOLDER_SESSION_DATES = "{session_dates}"

    val ALL_PLACEHOLDERS: List<String> = listOf(
        PLACEHOLDER_PATIENT_NAME,
        PLACEHOLDER_AMOUNT_OWED,
        PLACEHOLDER_SESSION_COUNT,
        PLACEHOLDER_SESSION_DATES,
    )
}

// Must stay in sync with the reminder_template DEFAULT in
// supabase/migrations/00000000000000_initial_schema.sql (profiles table).
const val DEFAULT_REMINDER_TEMPLATE: String =
    "Hola {patient_name}, te recuerdo que tenés un saldo pendiente de {amount_owed} " +
        "correspondiente a {session_count} sesión(es). ¡Gracias!"
